export function currencyMapper(input?: string): string {
  return input ?? '$'
}
